import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, setLogin, setAuthInfo, clearAuthError, setPermissions } from "../../store/slices/authSlice";
import LoginForm from "../../components/auth/LoginForm";
import { useNavigate } from "react-router-dom";
import Logo from "../../components/logo/logo";

const Login = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.auth.isLoading);
    const authError = useSelector(state => state.auth.authError);

    const navigate = useNavigate();
    
    useEffect(() => {
      dispatch(clearAuthError()); // Clear error when component mounts
    }, [dispatch]);

    // from LoginForm
    const handleLogin = async (formData) => {
        dispatch(clearAuthError());

        const resultAction = await dispatch(login(formData));
        if (login.fulfilled.match(resultAction)) {
            const { token, admin, permissions } = resultAction.payload;
            dispatch(setAuthInfo({ token, admin }));
            dispatch(setPermissions(permissions || []));
            dispatch(setLogin({ isLoggedIn: true }));
            navigate("/dashboard");
        } else {
            const errorMessage = resultAction.payload?.errors?.[0]?.msg || resultAction.payload?.message || 'Login failed';
            console.error('Login failed:', errorMessage);
        }
    };

    return (
      <div className="flex min-h-screen bg-gradient-to-br from-teal-50 via-white to-blue-50">
        {/* Left Side - Branding/Image */}
        <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary to-teal-600 items-center justify-center p-12">
          <div className="text-center text-white">
            <div className="mb-8 flex justify-center">
              <Logo />
            </div>
            <h1 className="text-4xl font-bold mb-4">Welcome Back!</h1>
            <p className="text-xl opacity-90">Sign in to access your admin dashboard</p>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            {/* Mobile Logo */}
            <div className="lg:hidden mb-8 text-center">
              <Logo />
            </div>

            {/* Login Card */}
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">Sign In</h2>
                <p className="text-gray-600">Enter your credentials to continue</p>
              </div>

              {/* Login Form */}
              <LoginForm onSubmit={handleLogin} isLoading={isLoading} authError={authError} />
            </div>

            {/* Footer */}
            <p className="text-center text-gray-500 text-sm mt-6">
              © 2025 EHR Admin. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    );
};

export default Login;
